/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { StyledPriceIncludeTaxesDiv } from './priceTaxFilter.styles';
import { Checkbox } from '@marriott/mi-ui-library-shop';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../availabilityFilters/availabilityFilterConstant';
// import { CheckBox } from '@marriott/mi-ui-library';
import { useWindowSize } from '@marriott/mi-ui-library';
import { StyledAvailabilityFilterHeaderContainerDiv } from '../availabilityFilters/availabilityFilter.styles';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}
type PriceTaxFilterProps = {
  handleDynamicPricesAndTax: (val: boolean) => void;
  isTaxSliderActive: boolean;
  filterTaxesLabel?: string;
  priceLabel?: string;
};

export const ShowPriceTaxFilter: React.FC<PriceTaxFilterProps> = ({
  handleDynamicPricesAndTax,
  isTaxSliderActive,
  filterTaxesLabel,
  priceLabel,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const clickTrackingLoc = 'Phoenix Search Results';
  const [isTaxesSliderActive, setIsTaxesSliderActive] = useState<boolean>(isTaxSliderActive);
  const { width } = useWindowSize();

  useEffect(() => {
    setIsTaxesSliderActive(isTaxSliderActive);
  }, [isTaxSliderActive]);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  const handleTaxesSelection = (event: any): void => {
    event?.stopPropagation();
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      handleDynamicPricesAndTax(!isTaxesSliderActive);
      setIsTaxesSliderActive(!isTaxesSliderActive);
      // setInteractionsSelected({ ...interactionsSelected, taxesAndFees: true });
    }
  };

  return (
    <div>
      {priceLabel && priceLabel.length && <fieldset>
          <StyledAvailabilityFilterHeaderContainerDiv className="t-font-alt-m">
            <legend>
              <h4
                className={
                  (width && width > BREAKPOINT_DESKTOP_1023
                    ? `t-subtitle-l`
                    : width && width > BREAKPOINT_TABLET
                    ? `t-subtitle-l`
                    : `t-subtitle-m`) + ' filter-heading mb-0'
                }
              >
                {priceLabel}
              </h4>
            </legend>
          </StyledAvailabilityFilterHeaderContainerDiv>
        </fieldset>}
      <StyledPriceIncludeTaxesDiv className="t-label-alt-m">
        <label
          className="include-taxes-and-fees-price-label t-font-s custom_click_track"
          tabIndex={-1}
          aria-hidden
          {...{
            custom_click_track_value: `${clickTrackingLoc}|${filterTaxesLabel} |internal`,
          }}
        >
          {filterTaxesLabel}
        </label>
        <Checkbox
          checkboxId="include-taxes-and-fees-price"
          onChange={(): void => {
            handleDynamicPricesAndTax(!isTaxesSliderActive);
            setIsTaxesSliderActive(!isTaxesSliderActive);
          }}
          checkboxName="include-taxes-and-fees-price"
          variation="switch"
          inputClassName="custom_click_track"
          checked={isTaxesSliderActive}
          {...{
            custom_click_track_value: `${clickTrackingLoc}| ${filterTaxesLabel} |internal`,
            tabIndex: -1,
          }}
          children={<span className="ada-hide">{filterTaxesLabel} </span>}
          ariaLabel={filterTaxesLabel}
          setTabIndex={-1}
          onKeyDown={(e): void => handleTaxesSelection(e)}
        />
      </StyledPriceIncludeTaxesDiv>
    </div>
  );
};
